import React from 'react'
import ReactAudioPlayer from 'react-audio-player'
import ForwardPlayIcon from '../../assets/forward_play_icon.svg'
import BackwardPlayIcon from '../../assets/backward_play_icon.svg'
import PauseIcon from '../../assets/pause.svg'
import PlayIcon from '../../assets/play_icon.svg'
import ShareButton from 'cwp-components/ShareButton'

const SvgIcon = ({ src, alt, ...props }) => (
  <img src={src} alt={alt} {...props} />
)

interface AudioPlayerProps {
  episode: any
  shareData: any
  audioPlayer?: any
}

const AudioPlayer = ({ episode, shareData, audioPlayer }: AudioPlayerProps) => {
  if (!audioPlayer) return null
  const {
    audioRef,
    isPlaying,
    currentTime,
    duration,
    togglePlayPause,
    forward,
    backward,
    formatTime,
    progress,
    handleSeekBarClick,
    handleSeekStart,
    reset,
    reactAudioPlayerProps,
  } = audioPlayer
  return (
    <div className='bg-white rounded-xl shadow-lg p-4 w-full lg:w-auto'>
      <div className='flex items-center space-x-4'>
        <img
          src={episode.icon_image || episode.banner_image}
          alt='Thumbnail'
          className='w-16 h-16 rounded-lg object-cover'
        />
        <div className='flex-1'>
          <div className='flex flex-col sm:flex-row items-start sm:items-center min-w-0 w-full lg:w-[280px]'>
            <h3
              className='font-semibold text-gray-800 w-full lg:truncate'
              title={episode.title}
            >
              {episode.title}
            </h3>
          </div>

          <p className='text-sm text-gray-600'>{episode.publisher.name}</p>
        </div>
      </div>
      <div className='mt-4'>
        <div
          id='custom-progress-bar'
          className={`relative w-full cursor-pointer py-3`}
          onClick={handleSeekBarClick}
          onMouseDown={handleSeekStart}
          onTouchStart={handleSeekStart}
        >
          <div className='absolute top-1/2 left-0 w-full h-1.5 -translate-y-1/2 rounded-full bg-gray-200'>
            <div
              className='bg-[#5858DF] h-1.5 rounded-full'
              style={{ width: `${progress * 100}%` }}
            ></div>
          </div>
        </div>
        <div className='flex justify-between text-xs text-gray-500 mt-1'>
          <span>{formatTime(currentTime)}</span>
          <span>{formatTime(duration)}</span>
        </div>
      </div>
      <div className='flex mt-4'>
        <div className='w-[40%] flex justify-between items-center'>
          <button
            className='text-gray-600 hover:text-gray-800 p-2'
            onClick={backward}
          >
            <SvgIcon
              src={BackwardPlayIcon}
              alt='Backward'
              className='w-6 h-6'
            />
          </button>
          <button
            className='bg-white text-[#5858DF] rounded-full p-3 hover:bg-gray-100'
            style={{ boxShadow: '0px 2px 8px 0px rgba(0, 0, 0, 0.15)' }}
            onClick={togglePlayPause}
          >
            {isPlaying ? (
              <SvgIcon
                src={PauseIcon}
                alt='Pause'
                className='h-[16px] w-[16px]'
              />
            ) : (
              <SvgIcon
                src={PlayIcon}
                alt='Play'
                className='w-4 h-4 transform scale-[1.75] translate-y-[20%]'
              />
            )}
          </button>
          <button
            className='text-gray-600 hover:text-gray-800 p-2'
            onClick={forward}
          >
            <SvgIcon src={ForwardPlayIcon} alt='Forward' className='w-6 h-6' />
          </button>
        </div>
        <div className='w-[60%] flex justify-end items-center'>
          <ShareButton data={shareData} />
        </div>
      </div>
      <ReactAudioPlayer
        src={episode.audio_file}
        ref={audioRef}
        {...reactAudioPlayerProps}
      />
    </div>
  )
}

export default AudioPlayer
